import classNames from 'classnames';
import styles from './chevron.module.less';

const Chevron = ({ isOpen = false, direction = 'down', className }) => (
    <i
        className={classNames(`fa-solid fa-chevron-${direction}`, styles.arrowIcon, isOpen && styles.rotate, className)}
        aria-hidden
    />
);
export default Chevron;
